import React, { useEffect, useState } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import CRPBlockWrapper from './CRPBlockWrapper';

import FaPlay from 'react-icons/lib/fa/play';
import FaPause from 'react-icons/lib/fa/pause';
import FaThumbsUp from 'react-icons/lib/fa/thumbs-o-up';
import FaThumbsDown from 'react-icons/lib/fa/thumbs-o-down';

import AmiraCircle from "../../../images/AmiraDialogCircle.png";
import StudentCircle from "../../../images/StudentDialogCircle.png";
import Loading from '../../Global/Loading';

const BLOCK_TITLE = "Review Dialogue";

const SPEAKER_AMIRA = "SPEAKER_AMIRA";
const SPEAKER_STUDENT = "SPEAKER_STUDENT";

let timer;

function Dialog({ dialog, onPlayCallback, onPauseCallback, audioPlaying, onAdjustFeedback, showPrompt = true }) {
  const { prompt, responseSummary, studentResponse, patter, audio, feedback } = dialog;
  const recordingUrl = audio?.url;
  const [currentTime, setCurrentTime] = useState("00:00");
  const [duration, setDuration] = useState("00:00");
  const [trackProgress, setTrackProgress] = useState(0);
  const [audioElement, setAudioElement] = useState(null);
  const [loading, setLoading] = useState(false);

  function onPlay() {
    if (audioElement) {
      timer = setInterval(() => {
        updateCurrentTime();
      }, 1000);
      audioElement.audioEl.play();
      if (onPlayCallback) {
        onPlayCallback();
      }
    }
  }

  function onPause() {
    if (audioElement) {
      clearInterval(timer);
      audioElement.audioEl.pause();
      if (onPauseCallback) {
        onPauseCallback();
      }
    }
  }

  function updateCurrentTime() {
    if (audioElement && audioElement.audioEl) {
      var minutes =
        "0" + parseInt(audioElement.audioEl.currentTime / 60, 10);
      var seconds = "0" + parseInt(audioElement.audioEl.currentTime % 60);
      const trackProgress =
        (audioElement.audioEl.currentTime /
          audioElement.audioEl.duration) *
        100;
      setCurrentTime(minutes + ":" + seconds.slice(-2));
      setTrackProgress(trackProgress);
    } else {
      setCurrentTime("00:00");
      setTrackProgress(0);
    }
  }

  function audioFinished() {
    clearInterval(timer);

    setCurrentTime("00:00");
    setTrackProgress(0);

    if (onPauseCallback) {
      onPauseCallback();
    }
  }

  function renderSpeakerImage(speaker) {
    let image;

    if (speaker === SPEAKER_AMIRA) {
      image = "https://www.amiralearning.com/images/homepage_AmiraPose1.png";
    } else {
      image = "https://static.vecteezy.com/system/resources/previews/005/228/939/original/avatar-man-face-silhouette-user-sign-person-profile-picture-male-icon-black-color-illustration-flat-style-image-vector.jpg";
    }
    
    return (
      <div className={`speaker ${speaker === SPEAKER_AMIRA ? "amira" : "student"}`}>
        <img src={speaker === SPEAKER_AMIRA ? AmiraCircle : StudentCircle} />
      </div>
    );
  }

  async function onThumbClicked(value) {
    setLoading(true);
    await onAdjustFeedback(value);
    setLoading(false);
  }

  function renderThumbRating() {
    return (
      <div className='thumbRatingContainer'>
        {loading && <Loading noFill/>}
        {!loading && (
          <>
            <FaThumbsUp 
              size="40" 
              className={`buttonSvg thumbsUp ${feedback === 1 ? 'active' : ''}`} 
              onClick={() => onThumbClicked(feedback === 1 ? null : 1)}
            />
            <FaThumbsDown 
              size="40"
              className={`buttonSvg thumbsDown ${feedback === -1 ? 'active' : ''}`}
              onClick={() => onThumbClicked(feedback === -1 ? null : -1)}
            />
          </>
        )}
      </div>
    )
  }

  function renderSpeechBubble(speaker, text) {
    return (
      <div className={`speechBubble ${speaker === SPEAKER_AMIRA ? "amira" : "student"}`}>
        {speaker === SPEAKER_AMIRA && <div className='text'>{text}</div>}
        {speaker === SPEAKER_STUDENT && (!recordingUrl || !recordingUrl.length) && <div className='text'>{text}</div>}
        {speaker === SPEAKER_STUDENT && recordingUrl && recordingUrl.length > 0 && (
          <div className="recordingContainer">
            <ReactAudioPlayer
              src={recordingUrl}
              ref={(element) => {
                setAudioElement(element);
              }}
              onLoadedMetadata={(e) => {
                if (audioElement) {
                  var minutes = "0" + parseInt(e.target.duration / 60, 10);
                  var seconds = "0" + parseInt(e.target.duration % 60);
                  setDuration(minutes + ":" + seconds.slice(-2));
                }
            }}
              onEnded={audioFinished}
            />
            <div className="recordingPlayerContainer">
              <div className="recordingControlsContainer">
                <div
                  className={`playControlContainer ${audioPlaying ? 'audioPlaying' : ''}`}
                  onClick={
                    !audioPlaying
                      ? onPlay
                      : onPause
                  }
                >
                  {!audioPlaying ? 
                    (<FaPlay size="70" className="buttonSvg play"/>) :
                    (<FaPause size="70" className="buttonSvg pause"/>)
                  }
                </div>
                <div className="audioTime">
                  {currentTime} / {duration}
                </div>
                <div className="audioPositionContainer">
                  <div className="fullAudioTrack" />
                  <div
                    className="playedAudioTrack"
                    style={{ width: `${trackProgress}%` }}
                  >
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      {showPrompt && prompt && (
        <div className='dialog'>
        {renderSpeakerImage(SPEAKER_AMIRA)}
        <div className='speechBubbleWrapper amira'>
          {renderSpeechBubble(SPEAKER_AMIRA, prompt)}
        </div>
          <div className='spacer' />
        </div>
      )}
      {responseSummary && (
        <div className='dialog'>
          <div className='spacer' />
          <div className='speechBubbleWrapper student'>
            <div className='studentText'>{responseSummary}</div>
            <div className='studentSpeechBubbleInner'>
              {renderSpeechBubble(SPEAKER_STUDENT, studentResponse)}
              {renderSpeakerImage(SPEAKER_STUDENT)}
            </div>
          </div>
        </div>
      )}
      {patter && (
        <div className='dialog'>
          {renderSpeakerImage(SPEAKER_AMIRA)}
          <div className='speechBubbleWrapper amira'>
            {renderSpeechBubble(SPEAKER_AMIRA, patter)}
          </div>
          {renderThumbRating()}
        </div>
      )}
    </>
  );
}

export default function CRPDialogBlock({ dialogs, onAdjustFeedback }) {
  const [playingId, setPlayingId] = useState(null);

  const handlePlay = (id) => {
    if (playingId !== id) {
      setPlayingId(id);
    }
  };

  const handlePause = (id) => {
    setPlayingId(null);
  }

  return (
    <CRPBlockWrapper title={BLOCK_TITLE}>
      <div className='dialogBlock'>
        {dialogs && dialogs.map((dialog, index) => (
          <Dialog
            dialog={dialog} 
            key={index} 
            audioPlaying={playingId === index} 
            onPlayCallback={() => handlePlay(index)}
            onPauseCallback={() => handlePause(index)}
            onAdjustFeedback={(value) => onAdjustFeedback(index, value)}
            showPrompt={index === 0}
          />
        ))}
      </div>
    </CRPBlockWrapper>
  )
}